const cache = new Map();

export function useIconCache() {
  /*
  Finds and writes Icon to Cache
  Params: none
  Returns: nothing
  Affects: cache
*/

  const setUrlToCache = async (url) => {
    if (!cache.has(url)) {
      try {
        const image = require(url);
        cache.set(
          url,
          fetch(image).then((r) => r.text())
        );
      } catch (ev) {
        cache.delete(url);
      }
    }
  };
  const setImageToCache = async (name) => {
    if (!cache.has(name)) {
      try {
        const image = require(`/src/assets/svg/${name}.svg`);
        cache.set(
          name,
          fetch(image).then((r) => r.text())
        );
      } catch (ev) {
        cache.delete(name);
      }
    }
  };

  /*
  Gets Icon from Cache and writes into DOM
  Params: none
  Returns: nothing
  Affects: icon
*/
  const getImageFromCache = async (name, icon) => {
    if (cache.has(name)) {
      try {
        let element = await cache.get(name);
        icon.value.innerHTML = element;
      } catch (err) {
        cache.delete(name);
      }
    }
  };
  return { setImageToCache, setUrlToCache, getImageFromCache };
}
